import React from 'react';
import { Outlet } from 'react-router-dom';

export const Schedules: React.FC = () => {
  return <Outlet />;
};
